import { create } from "zustand";
import { ArchiveSlice, createArchiveStore } from "./archive.store";

export const useArchiveStore = create<ArchiveSlice>((...args) => ({
	...createArchiveStore(...args),
}));
